import { Button, FilterDrawer, FormGroup, QuerySelector } from "@vesatogo/grass-core"
import { DateInput } from "@vesatogo/grass-dates"
import { Funnel } from "phosphor-react"
import { Dispatch, SetStateAction, useState } from "react"
import { useUsersQuery } from "~/generated/graphql"
import { FilterType } from "./receipts/index"

type InvoiceFilterProps = {
  filter: FilterType
  setFilter: Dispatch<SetStateAction<FilterType>>
}
const InvoiceFilter = ({ filter, setFilter }: InvoiceFilterProps) => {
  const [isOpen, setOpen] = useState(false)

  function inputProps(path: string) {
    return {
      value: filter[path],
      onChange: (e: any) => {
        setFilter(prev => ({
          ...prev,
          [path]: e?.target ? e.target.value : e,
        }))
      },
    }
  }

  function getAppliedFilters(prefix: string, filter: any) {
    const totalApplied = Object.keys(filter)?.filter?.(
      key => key.startsWith(prefix) && filter[key]
    )?.length
    return totalApplied ? `${totalApplied} Applied` : null
  }
  return (
    <>
      <Button
        onClick={() => {
          setOpen(prev => !prev)
        }}
        variant="minimal"
        className="items-center"
      >
        <Funnel />
      </Button>
      <FilterDrawer
        tabs={[
          {
            id: 1,
            title: "Seller/Buyer",
            subtitle: getAppliedFilters("sb", filter),
            content: (
              <>
                <FormGroup
                  label="Farmer"
                  className={"mb-2"}
                  helperText="seller"
                >
                  <QuerySelector
                    serverSideQuery
                    dataHook={useUsersQuery}
                    variables={{ group: "Farmer" }}
                    {...inputProps("sb_seller")}
                  />
                </FormGroup>
                <FormGroup label="Trader" className={"mb-2"} helperText="buyer">
                  <QuerySelector
                    serverSideQuery
                    dataHook={useUsersQuery}
                    variables={{ group: "Trader" }}
                    {...inputProps("sb_buyer")}
                  />
                </FormGroup>
              </>
            ),
          },
          {
            id: 2,
            title: "Others",
            subtitle: getAppliedFilters("oth", filter),
            content: (
              <div className="flex flex-col gap-3">
                <FormGroup label="Created At" className={"w-full"}>
                  <DateInput
                    className={"w-full"}
                    {...inputProps("oth_created_at")}
                  />
                </FormGroup>
              </div>
            ),
          },
        ]}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onApply={() => {
          setOpen(false)
        }}
        onClearAll={() => {
          setFilter({})
          setOpen(false)
        }}
      />
    </>
  )
}

export default InvoiceFilter
